module.exports = __webpack_public_path__ + "assets/img/saules-energija-namui.43c593ed.webp";